import React from 'react';

const Marker = (props: any) => {
    const { color, name, id } = props;
    return (
      <div>
        <div
          className="pin bounce"
          style={{ backgroundColor: color, cursor: 'pointer' }}
          title={name}
        />
        <div className="addressDetails">
            <p>#7-101, Bazar Street, Beside New Syndicate Bank,
            GUDUR 524 101. AP.<br/>
            <b>Email:</b> <a href="mailto:chalorestro@gmail.com">chalorestro@gmail.com</a><br/>
            <b>Call US:</b> +91 9494 71 0123</p>
        </div>
        <div className="pulse" />
      </div>
    );
  };

  export default Marker;